import React from 'react';

import WinXP from 'WinXP';
import BootScreen from 'components/BootScreen';

const App = () => {
  return (
    <BootScreen>
      <WinXP />
    </BootScreen>
  );
};

export default App;
